@if ((useLazyLoad && !isLoaded) || cards?.length > 0) {
  <wc-wrapper [contentWrapper]="wrapper" [componentWidth]="absoluteWidth">
    <sd-visual-cards sd-component-wrapper-component
      [brand]="brandCorner"
      [cards]="cards"
      [visualCardsSize]="size"
      [titleLevel]="titleLevel"
      [isDescription]="isDescription"
      [invertTitle]="invertTitle"
      [layoutTextConfig]="cardLayout"
      [twicPicsAutoSize]="!isFirst"
      [isLoading]="useLazyLoad && !isLoaded"
    />
  </wc-wrapper>
}
